module.exports = __webpack_public_path__ + "img/2016.9dfc84b5.png";